function handleVariantChange(containerSelector, targetSelector) {
  document.querySelectorAll(`${containerSelector} variant-selects input`).forEach(input => {
    input.addEventListener('change', function () {
      const wrapper = this.closest('variant-selects');
      if (!wrapper) return;

      wrapper.querySelectorAll('input:checked').forEach(option => {
        let optionId = option.getAttribute('data-option-value-id');
        const targetInput = document.querySelector(`${targetSelector} variant-selects input[data-option-value-id="${optionId}"]`);
        if (targetInput) targetInput.click();
      });
    });
  });
}

function syncInputValue(sourceSelector, targetSelector) {
  const sourceInput = document.querySelector(sourceSelector);
  const targetInput = document.querySelector(targetSelector);
  if (sourceInput && targetInput) {
    sourceInput.addEventListener('change', function () {
      targetInput.value = this.value;
    });
  }
}

function syncButtonClick(sourceSelector, targetSelector) {
  const sourceButton = document.querySelector(sourceSelector);
  const targetButton = document.querySelector(targetSelector);
  if (sourceButton && targetButton) {
    sourceButton.addEventListener('click', function () {
      targetButton.click();
    });
  }
}

// Handle variant changes
handleVariantChange('.product-bar', '.product');
handleVariantChange('.product', '.product-bar');

// Sync quantity inputs
syncInputValue('.product-bar .quantity__input', '.product .quantity__input');
syncInputValue('.product .quantity__input', '.product-bar .quantity__input');

// Sync form submit button
syncButtonClick('.product-bar .product-form__submit', '.product .product-form__submit');

function toggleProductBarVisibility() {
  const productButtons = document.querySelector('.product .product__buttons');
  const productBar = document.querySelector('.product-bar');

  if (!productButtons || !productBar) return;

  function checkVisibility() {
    const rect = productButtons.getBoundingClientRect();
    const screenCenter = window.innerHeight / 2 - 200;

    if (rect.top <= screenCenter) {
      productBar.classList.add('visible');
    } else {
      productBar.classList.remove('visible');
    }
  }

  document.addEventListener('scroll', checkVisibility);
  checkVisibility(); // Initial check in case it's already past center
}

// Initialize the function
toggleProductBarVisibility();
